import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import constants from "../common/constants";
const { ADMIN, USER } = constants;

const PrivateRoute = ({ element, requiredRole, allowedRoles }) => {
  const storeData = useSelector((state) => state.mainReducer);
  const { userData } = storeData;

  const allowed = allowedRoles ?? (Array.isArray(requiredRole) ? requiredRole : [requiredRole]);

  if (userData && !allowed.includes(userData?.role)) {
    return <Navigate to={userData.role === USER ? "/app/my-photos" : "/app/gallery"} replace />;
  }

  return element;
};

export default PrivateRoute;
